export const SET_META_VALUES = 'SET_META_VALUES';

export const setMetaValues = (payload) => {
    return {
        type: SET_META_VALUES,
        payload: {...payload}
    }
}